import { startStageCommand } from "../../domain/startStage.js";
import type { Command } from "../../domain/types/index.js";
import type { ResultExit } from "./resultExit.js";

export function ResultNav({
  stageId,
  dispatch,
  exit,
}: {
  stageId: string;
  dispatch: (command: Command) => void;
  exit?: ResultExit;
}) {
  return (
    <>
      <button
        type="button"
        className="btn btn-primary"
        onClick={() => dispatch(startStageCommand(stageId))}
      >
        もう一度このステージを遊ぶ
      </button>
      {exit ? (
        <a className="btn" href={exit.href}>{exit.label}</a>
      ) : (
        <button
          type="button"
          className="btn"
          onClick={() => dispatch({ type: "OPEN_STAGE_SELECT" })}
        >
          ステージセレクトに戻る
        </button>
      )}
    </>
  );
}
